<template>
  <v-dialog v-model="showDialog" persistent transition="dialog-transition" max-width="450">
    <v-card>
      <v-card-title class="text-title">
        Group Analysis
        <span class="d-inline-block ml-auto">
          <v-btn @click="loadGroupAnalyses()" :disabled="isLoadingAnalyses" icon>
            <v-icon color="primary">mdi-database-refresh</v-icon>
          </v-btn>

          <v-btn @click="loadGroupAnalysesB()" :disabled="isLoadingAnalyses" icon>
            <v-icon color="error">mdi-database-refresh-outline</v-icon>
          </v-btn>

          <v-btn @click="loadGroupAnalysesC()" :disabled="isLoadingAnalyses" icon>
            <v-icon color="success">mdi-database-refresh-outline</v-icon>
          </v-btn>

          <v-btn
            v-show="analysesReportAvailable"
            @click="showContactList()"
            :disabled="isLoadingAnalyses"
            icon
          >
            <v-icon>mdi-card-account-mail</v-icon>
          </v-btn>

          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" :disabled="isLoadingAnalyses">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="openEditGroupTimelineDialog()">
                <v-list-item-title class="text-subtitle-2">Set Timeline</v-list-item-title>
              </v-list-item>

              <v-list-item @click="showBreakdownByName()">
                <v-list-item-title class="text-subtitle-2">Breakdown by name</v-list-item-title>
              </v-list-item>

              <v-list-item @click="showBreakdownByPrice()">
                <v-list-item-title class="text-subtitle-2">Breakdown by cost price</v-list-item-title>
              </v-list-item>

              <v-list-item @click="showBreakdownByOrders()">
                <v-list-item-title class="text-subtitle-2">Breakdown by orders</v-list-item-title>
              </v-list-item>

              <v-list-item @click="showBreakdownBySales()">
                <v-list-item-title class="text-subtitle-2">Breakdown by sales</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </v-card-title>

      <v-fade-transition leave-absolute>
        <v-card-text v-if="isLoadingAnalyses" class="d-flex justify-center align-center mt-3">
          <v-progress-circular :size="70" color="primary darken-4" indeterminate></v-progress-circular>
        </v-card-text>

        <v-card-text v-else>
          <div class="text-subtitle-2 grey--text">Name: {{ groupName }}</div>

          <div class="text-subtitle-2 grey--text">Description: {{ groupDescription }}</div>

          <div class="text-subtitle-2 grey--text">From: {{ fromTimeline }}</div>

          <div class="text-subtitle-2 grey--text mb-2">To: {{ toTimeline }}</div>

          <div class="text-subtitle-1 grey--text">Expected Revenue: GH₵ {{ expectedRevenue }}</div>

          <div class="text-subtitle-1 grey--text">
            Expected Cost:
            <span class="error--text">GH₵ {{ expectedCost }}</span>
          </div>

          <div class="text-subtitle-1 grey--text">
            Expected Profit:
            <span class="success--text">GH₵ {{ expectedProfit }}</span>
          </div>

          <v-divider></v-divider>

          <div class="text-subtitle-1 grey--text">
            Actual Revenue: GH₵ {{ actualRevenue }}
            <span>
              (
              <v-icon small>mdi-triangle-outline</v-icon>
              {{ Number(expectedRevenue) - Number(actualRevenue) }})
            </span>
          </div>

          <div class="text-subtitle-1 grey--text">
            Actual Cost:
            <span class="error--text">GH₵ {{ actualCost }}</span>
            <span class="error--text">
              (
              <v-icon color="error" small>mdi-triangle-outline</v-icon>
              {{ Number(expectedCost) - Number(actualCost) }})
            </span>
          </div>

          <div class="text-subtitle-1 grey--text">
            Actual Profit:
            <span class="success--text">GH₵ {{ actualProfit }}</span>
            <span class="success--text">
              (
              <v-icon color="success" small>mdi-triangle-outline</v-icon>
              {{ Number(expectedProfit) - Number(actualProfit) }})
            </span>
          </div>
        </v-card-text>
      </v-fade-transition>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text color="primary darken-4" @click="closeDialog()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GroupAnalysesDialog",
  data() {
    return {
      groupName: "None",
      groupDescription: "None",
      fromTimeline: "None",
      toTimeline: "None",
      expectedRevenue: "None",
      actualRevenue: "None",
      expectedCost: "None",
      actualCost: "None",
      expectedProfit: "None",
      actualProfit: "None",
      isLoadingAnalyses: false
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setGroupAnalysesDialog", false);
    },

    loadGroupAnalyses() {
      this.isLoadingAnalyses = true;

      this.$store
        .dispatch("loadGroupAnalyses")
        .then(response => {
          this.groupName = response.data.group_name;
          this.groupDescription = response.data.group_description;
          this.fromTimeline = response.data.from_timeline;
          this.toTimeline = response.data.to_timeline;
          this.expectedRevenue = response.data.expected_revenue;
          this.actualRevenue = response.data.actual_revenue;
          this.expectedCost = response.data.expected_cost;
          this.actualCost = response.data.actual_cost;
          this.expectedProfit = response.data.expected_profit;
          this.actualProfit = response.data.actual_profit;
        })
        .finally(() => {
          this.isLoadingAnalyses = false;
        });
    },

    loadGroupAnalysesB() {
      this.isLoadingAnalyses = true;

      this.$store
        .dispatch("loadGroupAnalysesB")
        .then(response => {
          this.groupName = response.data.group_name;
          this.groupDescription = response.data.group_description;
          this.fromTimeline = response.data.from_timeline;
          this.toTimeline = response.data.to_timeline;
          this.expectedRevenue = response.data.expected_revenue;
          this.actualRevenue = response.data.actual_revenue;
          this.expectedCost = response.data.expected_cost;
          this.actualCost = response.data.actual_cost;
          this.expectedProfit = response.data.expected_profit;
          this.actualProfit = response.data.actual_profit;
        })
        .finally(() => {
          this.isLoadingAnalyses = false;
        });
    },

    loadGroupAnalysesC() {
      this.isLoadingAnalyses = true;

      this.$store
        .dispatch("loadGroupAnalysesC")
        .then(response => {
          this.groupName = response.data.group_name;
          this.groupDescription = response.data.group_description;
          this.fromTimeline = response.data.from_timeline;
          this.toTimeline = response.data.to_timeline;
          this.expectedRevenue = response.data.expected_revenue;
          this.actualRevenue = response.data.actual_revenue;
          this.expectedCost = response.data.expected_cost;
          this.actualCost = response.data.actual_cost;
          this.expectedProfit = response.data.expected_profit;
          this.actualProfit = response.data.actual_profit;
        })
        .finally(() => {
          this.isLoadingAnalyses = false;
        });
    },

    showContactList() {
      this.$store.commit("setAnalysesReportContactListDialog", true);
    },

    openEditGroupTimelineDialog() {
      this.$store.commit("setEditGroupTimelineDialog", true);
    },

    showBreakdownByName() {
      this.$store.commit("setBreakdownByNameDialog", true);
    },

    showBreakdownByPrice() {
      this.$store.commit("setBreakdownByPriceDialog", true);
    },

    showBreakdownByOrders() {
      this.$store.commit("setBreakdownByOrdersDialog", true);
    },

    showBreakdownBySales() {
      this.$store.commit("setBreakdownBySalesDialog", true);
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.analyses.groupAnalysesDialog;
    },

    analysesReportAvailable() {
      if (
        this.$store.state.analyses.breakdownItemsByPrice.length > 0 ||
        this.$store.state.analyses.breakdownItemsByName.length > 0
      )
        return true;
      else return false;
    }
  }
};
</script>

<style>
</style>